import styled from 'styled-components';

export const StyledFormContainer = styled.form`
  width: 100%;
`;
